module.exports = __webpack_public_path__ + "img/home_2.865bae25.jpg";